import * as React from "react";
import { Form, DatePicker, Divider, Checkbox } from "antd";
import {
  DateFormats,
  ApplicantsAppointmentForm as FormContants
} from "../../../common/Constants";
import moment from "moment";
import TextArea from "antd/lib/input/TextArea";
import Text from "antd/lib/typography/Text";
import SelectInput from "../../components/app/SelectInput";

const ApplicantsAppointmentForm = ({
  getFieldDecorator,
  translate,
  rowData,
  codebooks,
  readOnly = false
}: {
  getFieldDecorator: any;
  translate: any;
  rowData?: any;
  codebooks: any;
  readOnly?: boolean;
}) => {
  return (
    <Form>
      <Form.Item label={translate("applicant_appointment.position")}>
        {getFieldDecorator(FormContants.Fields.POSITION_TYPE_ID, {
          initialValue: rowData && rowData.positionTypeId.toString(),
          rules: [
            {
              required: true,
              message: translate("applicant_appointment.required_messages", {
                field: translate("applicant_appointment.position")
              })
            }
          ]
        })(
          <SelectInput
            placeholder={translate("applicant_appointment.select_position")}
            allowClear
            showSearch={true}
            notFoundContent={translate("search.no_data")}
            selectOptionKey={"id"}
            selectOptionValue={"name"}
            selectOptions={codebooks}
            disabled={readOnly}
          />
        )}
      </Form.Item>

      <Divider></Divider>

      <div className="ant-form-row-container">
        <Text style={{ fontWeight: "bold" }}>
          {"Podaci o imenovanju i trajanju mandata"}
        </Text>
        <div className="ant-form-row-two-items">
          <Form.Item
            label={translate("applicant_appointment.appointment_date")}
            className="ant-form-item-width"
          >
            {getFieldDecorator(FormContants.Fields.APPOINTMENT_DATE, {
              initialValue:
                rowData && moment(rowData.appointmentDate, DateFormats.DATE),
              rules: [
                {
                  required: true,
                  message: translate(
                    "applicant_appointment.required_messages",
                    {
                      field: translate("applicant_appointment.appointment_date")
                    }
                  )
                }
              ]
            })(
              <DatePicker
                placeholder={translate("applicant_appointment.select_date")}
                locale={{ dateFormat: DateFormats.DATE }}
                showToday={false}
                disabled={readOnly}
              />
            )}
          </Form.Item>
          <Form.Item
            label={translate("applicant_appointment.start_mandate")}
            className="ant-form-item-width"
          >
            {getFieldDecorator(FormContants.Fields.START_MANDATE, {
              initialValue:
                rowData && moment(rowData.startMandate, DateFormats.DATE),
              rules: [
                {
                  required: true,
                  message: translate(
                    "applicant_appointment.required_messages",
                    {
                      field: translate("applicant_appointment.start_mandate")
                    }
                  )
                }
              ]
            })(
              <DatePicker
                placeholder={translate("applicant_appointment.select_date")}
                locale={{ dateFormat: DateFormats.DATE }}
                showToday={false}
                disabled={readOnly}
              />
            )}
          </Form.Item>
        </div>

        <div className="ant-form-row-two-items">
          <Form.Item
            label={translate("applicant_appointment.predicted_end")}
            className="ant-form-item-width"
          >
            {getFieldDecorator(FormContants.Fields.PREDICTED_END, {
              initialValue:
                rowData && rowData.predictedEnd
                  ? moment(rowData.predictedEnd, DateFormats.DATE)
                  : undefined
            })(
              <DatePicker
                placeholder={translate("applicant_appointment.select_date")}
                locale={{ dateFormat: DateFormats.DATE }}
                showToday={false}
                disabled={readOnly}
              />
            )}
          </Form.Item>
          <Form.Item
            label={translate("applicant_appointment.end_mandate")}
            className="ant-form-item-width"
          >
            {getFieldDecorator(FormContants.Fields.END_MANDATE, {
              initialValue:
                rowData && rowData.endMandate
                  ? moment(rowData.endMandate, DateFormats.DATE)
                  : undefined
            })(
              <DatePicker
                placeholder={translate("applicant_appointment.select_date")}
                locale={{ dateFormat: DateFormats.DATE }}
                showToday={false}
                disabled={readOnly}
              />
            )}
          </Form.Item>
        </div>
      </div>

      <Divider></Divider>

      <Form.Item label={translate("applicant_appointment.description")}>
        {getFieldDecorator(FormContants.Fields.DESCRIPTION, {
          initialValue: rowData && rowData.description
        })(
          <TextArea
            placeholder={translate(
              "applicant_appointment.description_placeholder"
            )}
            autoSize={{ minRows: 3 }}
            disabled={readOnly}
          />
        )}
      </Form.Item>

      <Form.Item label={translate("applicant_appointment.appointment_valid")}>
        {getFieldDecorator(FormContants.Fields.APPOINTMENT_VALID, {
          initialValue: rowData ? rowData.appointmentValid : true,
          valuePropName: "checked",
          rules: [
            {
              required: true,
              message: translate("applicant_appointment.required_messages", {
                field: translate("applicant_appointment.appointment_valid")
              })
            }
          ]
        })(<Checkbox />)}
      </Form.Item>
    </Form>
  );
};

export default ApplicantsAppointmentForm;
